import classNames from "classnames";
import React, { useState } from "react";
import { useEffect } from "react";
import { Row, Container, FormLabel } from "react-bootstrap";
import { ValidationError } from "yup";

const DailyCheckinCard = ({ title, value, active, handleClick }) => {
  return (
    <div>
      <div
        className={classNames(
          "daily-checkin-card",
          { "background-finished": value === 0 && !active },
          { "background-unfinished": value > 0 && !active },
          { "border-chosen": active },
          { "background-chosen-finished": value === 0 && active },
          { "background-chosen-unfinished": value > 0 && active }
        )}
        onClick={handleClick}
      >
        <div>
          <div>
            <div className="card-body">
              <div className="row no-gutters align-items-center">
                <div className="col">
                  <div
                    id="title_text"
                    className="d-flex justify-content-center mb-4 font-weight-bold"
                  >
                    {title}
                  </div>
                  <div
                    id="value_text"
                    className="d-flex justify-content-center h5 mb-0 font-weight-bold"
                  >
                    {value}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DailyCheckinCard;
